export const lookupValue = (lookups = {}, key, index) => {
  const l1Value = lookups[key]?.[index];

  if (Array.isArray(l1Value)) {
    const l2Values = lookups[`${key}_l2`];
    return l1Value.map((inx) => l2Values?.[inx]);
  }

  return l1Value;
};
